import React, { useCallback } from "react";
import ReactFlow, {
  Background,
  Controls,
  MiniMap,
  applyNodeChanges,
} from "reactflow";
import "reactflow/dist/style.css";

const ReactFlowRenderer = ({ nodes, edges, onNodeClick, onNodesChange }) => {
  // Callback pour gérer le clic sur un nœud
  const handleNodeClick = useCallback(
    (event, node) => {
      if (onNodeClick) onNodeClick(node);
    },
    [onNodeClick]
  );

  return (
    <div
      style={{
        width: "100%",
        height: 400,
        border: "1px solid #60a5fa", // couleur et épaisseur de la bordure
        borderRadius: 12, // coins arrondis (optionnel)
        boxSizing: "border-box", // pour inclure la bordure dans la taille
        background: "#f8fafc", // fond clair optionnel
      }}
    >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodeClick={handleNodeClick}
        onNodesChange={onNodesChange}
        fitView
      >
        <MiniMap
          nodeColor={(n) => n.style?.background || "#f3f4f6"}
          nodeStrokeColor="#111827"
          nodeBorderRadius={8}
        />
        <Controls />
        <Background
          variant="dots" // "lines" ou "dots"
          gap={24} // espacement entre les points
          size={1.5} // taille des points
          color="#60a5fa" // couleur des points
        />
      </ReactFlow>
    </div>
  );
};

// Pour pouvoir utiliser applyNodeChanges dans TestFlowVisualizer
ReactFlowRenderer.applyNodeChanges = applyNodeChanges;

export default ReactFlowRenderer;
